import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import PaymentGatewayAnalyticsListing from '@/modules/bank/components/PaymentGatewayAnalytics'

function PaymentGatewayAnalyticsPage() {
	return (
		<PageContainer>
			<PaymentGatewayAnalyticsListing />
		</PageContainer>
	)
}

const GuardedPaymentGatewayAnalyticsPage = withUserPermission(
	PaymentGatewayAnalyticsPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_BANK_ACCOUNT],
	},
)

export default GuardedPaymentGatewayAnalyticsPage
